import { LinearProgress, Stack, Typography,Box } from '@mui/material';
import React from 'react';
import { AppColors } from '../../../Utils/helper/AppColors';

export default function MentionProgress({ value, hidePercentageSign, hideBar }) {
	return (
		 <Stack direction="row" alignItems="center" gap={1.5}>
            {!hideBar && (
                <Box sx={{ position: 'relative', width: 78, height: 10 }}>
                    {/* Progress Bar */}
                    <LinearProgress
                        sx={{
                            height: '100%',
                            borderRadius: 8,
                            '.MuiLinearProgress-bar': { borderRadius: 10 },
                            '&.MuiLinearProgress-root': { bgcolor: AppColors.BORDER_GREY },
                        }}
                        variant="determinate"
                        value={value}
                    />
                    {/* Text Inside Progress Bar (Right-Aligned) */}
                    <Typography
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            right: '5px', // Align text to the right
                            transform: 'translateY(-50%)', // Center vertically
                            fontSize: 8,
                            fontWeight: 500,
							lineHeight: '121%',
                            color: AppColors.BLACK,
                        }}
                    >
                        {value}
                        {!hidePercentageSign && '%'}
                    </Typography>
                </Box>
            )}
        </Stack>
	);
}
